module["exports"] = [
  "####",
  "###",
  "##",
  "#"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr/address/building_number.js
 ** module id = 669
 ** module chunks = 0
 **/